import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {toggleDownloadPreset} from "../../../services/action-creators";
import PresetsAccordion from "./PresetsAccordion";
import {Button} from "react-bootstrap";
import API from "../../../utils/httpAPI";

const Presets = ({file}) => {
    const dispatch = useDispatch();
    const { presetSelected } = useSelector((state) => state.file);
    const [downloadIsInProgress, setDownloadIsInProgress] = useState(false);
    let timerId = null;

    useEffect(() => {
        return () => {
            clearTimeout(timerId);
        };
    }, []);


    const handleClick = (presetName) => {
        dispatch(toggleDownloadPreset(presetName));
    }

    const handlePresetDownload = async () => {

        setDownloadIsInProgress(true);
        try {
            const { data } = await API({
                method: "post",
                url: "/export/preset",
                data: {
                    bulkId: file.id,
                    preset: presetSelected,
                }
            })

            const {download, url} = data;

            if (download.status === "created" && url) {
                setDownloadIsInProgress(false);
                return window.open(url, "_blank");
            }

            if (download.status !== "created") {

                const check = async(id) => {
                    const {data} = await API({method: "post", url: "export/check-status", data: {id: id}});

                    const {download, url} = data

                    if (download.status !== "created") {
                        timerId = setTimeout(check, 2000);
                    }

                    if (download.status === "created" && url) {
                        setDownloadIsInProgress(false);
                        return window.open(url, "_blank");
                    }
                }

                timerId = setTimeout(() => { check(download.id) }, 2000);
            }
        } catch (error) {
            // TODO: Add Error Handler
            setDownloadIsInProgress(false);
        }
    }

    const getListEntry = (text, type) => {
        return (
            <div className="description-preset-list">
                <img src={`images/clean/dm-${type}.svg`} alt=""/>
                <div className={`preset-text-${type}`}>{text}</div>
            </div>
        )
    };

    return (
        <>
            <div className="download-modal-content">
                <PresetsAccordion
                    alias={"deliverable"}
                    name={"Deliverable"}
                    isRecommended={true}
                    isActive={presetSelected === "deliverable"}
                    onSelect={handleClick}
                >
                    <>
                        <div className="description-h1">Deliverable</div>
                        <div className="description-text">This preset includes valid emails only, producing the lowest bounce rate possible when sending your compaign. Recommended for most senders.</div>
                        <div className="description-h2">Backed by our Delivery Guarantee. <span className="link-text-green">Read More.</span></div>
                        <div className="description-text">We are pleased to present dozens of new feauters and data enrichment categories to help in your list segmentation and sending process. To download your list based on our recommendation, select a preset.</div>
                        <div className="description-h2">Included Results:</div>
                        {getListEntry('Valids', 'ok')}
                        {getListEntry('Invalids', 'cancel')}
                        {getListEntry('Accept All (Unverifiable)', 'cancel')}
                        {getListEntry('Disposables', 'cancel')}
                        {getListEntry('Unknowns', 'cancel')}
                        {getListEntry('Duplicates', 'cancel')}
                        {getListEntry('Bad Syntax', 'cancel')}
                        <div className="description-text">Learn more about <span className="link-text-green">downloading your results.</span></div>
                    </>
                </PresetsAccordion>
                <PresetsAccordion
                    alias={"undeliverable"}
                    name={"Undeliverable"}
                    isRecommended={false}
                    isActive={presetSelected === "undeliverable"}
                    onSelect={handleClick}
                >
                    <>
                        <div className="description-h1">Undeliverable</div>
                        <div className="description-text">This preset includes all emails that are likely to be invalid or bounce upon sending. This category should only beused to suppress your existing databaseor list and should never be send without expert review.</div>
                        <div className="description-h2">Included Results:</div>
                        {getListEntry('Valids', 'cancel')}
                        {getListEntry('Invalids', 'ok')}
                        {getListEntry('Accept All (Unverifiable)', 'cancel')}
                        {getListEntry('Disposables', 'ok')}
                        {getListEntry('Unknowns', 'cancel')}
                        {getListEntry('Duplicates', 'cancel')}
                        {getListEntry('Bad Syntax', 'ok')}
                        <div className="description-text">Learn more about <span className="link-text-green">downloading your results.</span></div>
                    </>
                </PresetsAccordion>
                <PresetsAccordion
                    alias={"all"}
                    name={"All results"}
                    isRecommended={false}
                    isActive={presetSelected === "all"}
                    onSelect={handleClick}
                >
                    <>
                        <div className="description-h1">All results</div>
                        <div className="description-text">This preset includes all primari classifications of emails; valid, invalid, accept all (unverifiable), disposable, unknown, as well as duplicates and bad syntax. This segmentation should never be send directly without first categorizing the results.</div>
                        <div className="description-h2">Included Results:</div>
                        {getListEntry('Valids', 'ok')}
                        {getListEntry('Invalids', 'ok')}
                        {getListEntry('Accept All (Unverifiable)', 'ok')}
                        {getListEntry('Disposables', 'ok')}
                        {getListEntry('Unknowns', 'ok')}
                        {getListEntry('Duplicates', 'ok')}
                        {getListEntry('Bad Syntax', 'ok')}
                        <div className="description-text">Learn more about <span className="link-text-green">downloading your results.</span></div>
                    </>
                </PresetsAccordion>
            </div>
            <div className="download-modal-footer">
                <Button variant="success" disabled={downloadIsInProgress} onClick={handlePresetDownload}>
                    {downloadIsInProgress ? <><i className={"fa fa-spinner fa-spin"}/> Please wait</> : "Download"}
                </Button>
            </div>
        </>
    );

};

export default Presets;
